import script from "./popup.vue?vue&type=script&setup=true&lang=js"
export * from "./popup.vue?vue&type=script&setup=true&lang=js"

import "./popup.vue?vue&type=style&index=0&id=23b9981b&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/qpyx-korea-gm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23b9981b"]])

export default __exports__